import * as types from '../actions';

const initialState = {
    items: [],
    totalPage:0,
    numRows:0,
    count:'',
    item:{
        id:'',
        totalEvent:0,
        totalShift:0,
        totalSpend:'',
        logo:'',
        signature:'',
        client_affiliate_status:false,
        companyName:'',
        companyEmail:'',
        companyContactNum:'',
        websiteUrl:'',
        sector:0,
        subSector:0,    
        companyRegNum:'',
        vatNum:'', 

        location:'',
        googleLocation:'',
        streetOne:'',
        streetTwo:'',
        city:'',
        state:'',
        country:'',
        postcode:'',

        samePhysicalAddress: false,

        locationBilling:'',
        googleLocationBilling:'',
        streetOneBilling:'',
        streetTwoBilling:'',
        cityBilling:'',
        stateBilling:'',
        countryBilling:'',
        postcodeBilling:'',
        
        additionalText:'',
        prmyCnctAssUserId:'',
        prmyCnctUserId:'',
        emailVerify:true,
        firstName:'',
        lastName:'',
        contactNumber:'',
        emailAddress:'',  
        position:'',
        isPrmCnctList:false,   
        category:''   
    },
    sectors:[],  
    subSectors:[], 
    locations:[],
    prmryUsers:[],
    contactList:[],
    errorData:'',
    contactUser:{
        userId:'',
        firstName:'',
        lastName:'',
        contactNumber:'',
        emailAddress:'',  
        position:'',
        logo:'',
        role:''
    },
    subactivity:'',
    importSubactivity:'',
    contactActivity:'',
    contactUserData:'',
    roles:[],
    sendMailStatus:'',
    clientId:[],
    contactImportData:[],
    alreadyImported: false,
    activeStatus: false,
    status:0,
    activity:'',
    clientProfStatus:0,
    clientProfActivity:'',
    sliderClientId:0,
    clientCategoryListData:[],
    clientListCategoryWise:[],
    clientUpdatedData: [],
    clientFullData:[],
    clientFullListActivity:'',
    clientBasicInfoData:[],
    clientBasicInfoActivity:'',
    quickResponse:{},
    clientDepartmentsList:[], 
    clientDeptActivity: '',
};

export default function(state = initialState, action) {
    const response = action.response;
    let timeVar = '~~'+Date.now(); 
    switch(action.type) {

        case types.CLIENT_LIST_SLIDER_CLIENTID:
            return {
                ...state,
                sliderClientId:action.data
            }

        case types.SECTOR_ALL_SUPERADMIN_LIST_SUCCESS:
            return {
                ...state,
                sectors:response.data,
                status: response.status,  
                activity:types.SECTOR_ALL_SUPERADMIN_LIST_SUCCESS,                               

            };
        case types.PROFILE_CLIENT_CATEGORY_LIST_SUCCESS:
            return {
                ...state,
                clientCategoryListData:response.data,
                status: response.status,  
                activity:types.PROFILE_CLIENT_CATEGORY_LIST_SUCCESS,
                clientProfActivity: types.PROFILE_CLIENT_CATEGORY_LIST_SUCCESS+timeVar,                               

            };
        case types.CLIENT_LIST_FOR_CATEGORIES_SUCCESS:
            return {
                ...state,
                clientListCategoryWise:response.data,
                status: response.status,  
                activity:types.CLIENT_LIST_FOR_CATEGORIES_SUCCESS,
                clientProfActivity: types.CLIENT_LIST_FOR_CATEGORIES_SUCCESS+timeVar,                               

            };
        case types.SUBSECTOR_ALL_LIST_SUPERADMIN_SUCCESS:
            return {
                ...state,
                subSectors:response.data,
                status: response.status,   
                activity:types.SUBSECTOR_ALL_LIST_SUPERADMIN_SUCCESS,                              

            };
        case types.CLIENT_LIST_SUCCESS:
            if(response.status===200){
                let totalPage = Math.ceil(response.data.count/response.data.page_size);
                return {
                    ...state,
                    items: response.data.results,
                    status: response.status,
                    activity:types.CLIENT_LIST_SUCCESS,
                    totalPage: totalPage,
                    numRows:response.data.results.length,
                    count:response.data.count               
                };
            }else{
                return {
                    ...state,
                    status: response.status, 
                    activity:types.CLIENT_LIST_ERROR,                                
                };
            }

        case types.CLIENT_FULL_LIST_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    clientFullData: response.data,
                    status: response.status,
                    clientFullListActivity:types.CLIENT_FULL_LIST_SUCCESS+timeVar,              
                };
            }else{
                return {
                    ...state,
                    status: response.status, 
                    clientFullListActivity:types.CLIENT_FULL_LIST_ERROR+timeVar,                                
                };
            }
        case types.CLIENT_COMPANY_BASIC_INFO_SUCCESS:
            
            if(response.status===200){
                return {
                    ...state,
                    clientBasicInfoData: response.data,
                    status: response.status,
                    clientBasicInfoActivity:types.CLIENT_COMPANY_BASIC_INFO_SUCCESS+timeVar,              
                };
            }else{
                return {
                    ...state,
                    status: response.status, 
                    clientBasicInfoActivity:types.CLIENT_COMPANY_BASIC_INFO_ERROR+timeVar,                                
                };
            }
        
        case types.CLIENT_QUICK_ADD_SUCCESS:
            if(response.status===201){
                return {
                    ...state,
                    items: [...state.items],
                    status: response.status,
                    quickResponse: response.data,
                    activity:types.CLIENT_QUICK_ADD_SUCCESS,
                }
            }else{
                return {
                    ...state,
                    status: response.status, 
                    activity:types.CLIENT_QUICK_ADD_ERROR,    
                    errorData:response.data                            
                };
            }
       
        case types.CLIENT_EDIT_SUCCESS:
            if(response.status===200){
                let locationId      = 0;
                let locationName    = '';
                let locationLatLong = '';
                let lnVenue         = '';
                let lnStreetOne     = null;
                let lnStreetTwo     = null;
                let lnCity          = null;
                let lnState         = null;
                let lnCountry       = null;
                let lnPostcode      = null;

                let billinglocationId      = 0;
                let billinglocationName    = '';
                let billinglocationLatLong = '';
                let billinglnVenue         = '';
                let billinglnStreetOne     = null;
                let billinglnStreetTwo     = null;
                let billinglnCity          = null;
                let billinglnState         = null;
                let billinglnCountry       = null;
                let billinglnPostcode      = null;

                let pcFirstName     = null;
                let pcLastName      = null;
                let pcContactNum    = null;
                let pcEmail         = null;
                let pcPosition      = '';
                let pcPrmCnctList   = false;
                let pcAssUserId        = '';
                let pcUserId        = '';
                let pcEmailVerify   = true;
                let sectorId        = 0;
                let subSectorId     = 0;
                let muteMails       = false;
                let mutePushs       = false;

                if(response.data.location!==null){
                    locationId   = response.data.location.id;
                    locationName = response.data.location.location;
                    lnVenue      = response.data.location.venue;
                    lnStreetOne  = response.data.location.street1;
                    lnStreetTwo  = response.data.location.street2;
                    lnCity       = response.data.location.city;
                    lnState      = response.data.location.state;
                    lnCountry    = response.data.location.country;
                    lnPostcode   = response.data.location.postcode;
                    locationLatLong = response.data.location.lat_long;
                }

                if(response.data.location_billing!==null){
                    billinglocationId   = response.data.location_billing.id;
                    billinglocationName = response.data.location_billing.location;
                    billinglnVenue      = response.data.location_billing.venue;
                    billinglnStreetOne  = response.data.location_billing.street1;
                    billinglnStreetTwo  = response.data.location_billing.street2;
                    billinglnCity       = response.data.location_billing.city;
                    billinglnState      = response.data.location_billing.state;
                    billinglnCountry    = response.data.location_billing.country;
                    billinglnPostcode   = response.data.location_billing.postcode;
                    billinglocationLatLong = response.data.location_billing.lat_long;
                }

                
                if(response.data.associateusers_set.length>0){  
 
                    let filtered = response.data.associateusers_set.filter(function (el) {
                        return el != null;
                    });
                  
                    pcFirstName   = filtered[0].user.first_name;
                    pcLastName    = filtered[0].user.last_name;
                    pcContactNum  = filtered[0].phone_number;
                    pcEmail       = filtered[0].user.email;
                    pcPosition    = filtered[0].position;
                    pcPrmCnctList = response.data.associateusers_set.length==1 && filtered[0].user.email.length==0 ? false : true;
                    pcAssUserId   = filtered[0].id;
                    pcUserId      = filtered[0].user.id;
                    pcEmailVerify = filtered[0].email_verified;
                    muteMails     = filtered[0].mute_mails;
                    mutePushs     = filtered[0].mute_pushs;
                }

                if(response.data.sector!==null){   
                    sectorId      = response.data.sector.id;
                }
                if(response.data.sub_sector!==null){   
                    subSectorId   = response.data.sub_sector.id;
                }
                                
                return {
                    ...state,
                    item:{
                        id:response.data.id,
                        totalEvent:response.data.total_events,
                        totalShift:response.data.total_shifts,
                        //totalSpend:response.data.total_shifts,
                        logo:response.data.logo,
                        signature:response.data.signature,
                        companyName:response.data.company_name,
                        companyEmail:response.data.company_email?response.data.company_email:'',
                        companyContactNum:response.data.phone_number?response.data.phone_number:'',
                        websiteUrl:response.data.web_site,
                        sector:sectorId,
                        subSector:subSectorId, 
                        companyRegNum:response.data.company_no?response.data.company_no:'',
                        vatNum:response.data.vat_number?response.data.vat_number:'', 

                        location:locationName,
                        locationId:locationId,
                        googleLocation:locationLatLong,
                        venue:lnVenue,
                        streetOne:lnStreetOne,
                        streetTwo:lnStreetTwo,
                        city:lnCity,
                        state:lnState,
                        country:lnCountry,
                        postcode:lnPostcode,

                        locationBilling:billinglocationName,
                        locationIdBilling:billinglocationId,
                        googleLocationBilling:billinglocationLatLong, 
                        venueBilling:billinglnVenue,
                        streetOneBilling:billinglnStreetOne,
                        streetTwoBilling:billinglnStreetTwo,
                        cityBilling:billinglnCity,
                        stateBilling:billinglnState,
                        countryBilling:billinglnCountry,
                        postcodeBilling:billinglnPostcode,
                     
                        additionalText:response.data.note,   
                        firstName:pcFirstName,
                        lastName:pcLastName,
                        contactNumber:pcContactNum,
                        emailAddress:pcEmail, 
                        position:pcPosition,
                        isPrmCnctList:pcPrmCnctList,
                        prmyCnctAssUserId:pcAssUserId,  
                        prmyCnctUserId:pcUserId,  
                        emailVerify:pcEmailVerify,  
                        dynamic_fields:response.data.dynamic_fields,  
                        timeZone:response.data.region_time_zone,
                        is_active:response.data.is_active,                                                   
                        client_affiliate_status:response.data.client_affiliate_status,
                        category:response.data.client_category.id,
                        departments:response.data.departments,
                        muteMails:muteMails,                             
                        mutePushs:mutePushs                                                 
                    },
                    status: response.status,
                    activity: types.CLIENT_EDIT_SUCCESS,   
                    clientProfStatus: response.status,
                    clientProfActivity: types.CLIENT_EDIT_SUCCESS+timeVar,             
                }    
            }else{
                return {
                    ...state,
                    status:response.status,
                    activity:types.CLIENT_EDIT_ERROR,
                    clientProfStatus: response.status,
                    clientProfActivity: types.CLIENT_EDIT_ERROR+timeVar, 
                } 
            }
        case types.CLIENT_EDIT_ERROR: 
            return {
                ...state,
                status:response?.status ? response.status : '',
                activity:types.CLIENT_EDIT_ERROR,
                clientProfStatus: response?.status ? response.status : '', 
                clientProfActivity: types.CLIENT_EDIT_ERROR+timeVar, 
            } 

        case types.CLIENT_CMPNY_INFO_ADD_SUCCESS:
            if(response.status===201){
                return {
                    ...state,
                    item:{
                        id:response.data.profile_id,                       
                    },
                    newClientId: response.data.profile_id,   
                    status: response.status,
                    activity:types.CLIENT_CMPNY_INFO_ADD_SUCCESS,
                    clientProfStatus: response.status,
                    clientProfActivity: types.CLIENT_CMPNY_INFO_ADD_SUCCESS+timeVar,
                }
            }else{
                return {
                    ...state,
                    status: response.status,
                    activity:types.CLIENT_CMPNY_INFO_ADD_ERROR,
                    errorData:response.data, 
                    clientProfStatus: response.status,
                    clientProfActivity: types.CLIENT_CMPNY_INFO_ADD_ERROR+timeVar,
                }
            }
        case types.CLIENT_CMPNY_INFO_ADD_ERROR:   
            return {
                ...state,
                status: response.status,
                activity:types.CLIENT_CMPNY_INFO_ADD_ERROR,
                errorData:response.data, 
                clientProfStatus: response.status,
                clientProfActivity: types.CLIENT_CMPNY_INFO_ADD_ERROR+timeVar,
            }
        
        case types.CLIENT_CMPNY_INFO_UPDATE_SUCCESS:
            if(response.status===200){
                return {
                    ...state,                    
                    status:response.status,
                    activity:types.CLIENT_CMPNY_INFO_UPDATE_SUCCESS,
                    clientProfStatus: response.status,
                    clientProfActivity: types.CLIENT_CMPNY_INFO_UPDATE_SUCCESS+timeVar,
                    clientUpdatedData: response.data ? response.data : []
                } 
            }else{
                return {
                    ...state,
                    status:response.status,
                    activity:types.CLIENT_CMPNY_INFO_UPDATE_ERROR,
                    errorData:response.data, 
                    clientProfStatus: response.status,
                    clientProfActivity: types.CLIENT_CMPNY_INFO_UPDATE_ERROR+timeVar,
                } 
            } 
        case types.CLIENT_PRMRY_CNCT_ADD_SUCCESS:
            if(response.status===201){
                return {
                    ...state,
                    status:response.status,
                    activity:types.CLIENT_PRMRY_CNCT_ADD_SUCCESS,
                    clientProfStatus: response.status,
                    clientProfActivity: types.CLIENT_PRMRY_CNCT_ADD_SUCCESS+timeVar,
                }
            }else{
                return {
                    ...state,
                    status:response.status,
                    activity:types.CLIENT_PRMRY_CNCT_ADD_ERROR,
                    errorData:response.data,
                    clientProfStatus: response.status,
                    clientProfActivity: types.CLIENT_PRMRY_CNCT_ADD_ERROR+timeVar,
                }
            }
        case types.CLIENT_PRMRY_CNCT_UPDATE_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    status:response.status,
                    activity:types.CLIENT_PRMRY_CNCT_UPDATE_SUCCESS,
                    clientProfStatus: response.status,
                    clientProfActivity: types.CLIENT_PRMRY_CNCT_UPDATE_SUCCESS+timeVar,
                }
            }else{
                return {
                    ...state,
                    status:response.status,
                    activity:types.CLIENT_PRMRY_CNCT_UPDATE_ERROR,
                    errorData:response.data,
                    clientProfStatus: response.status,
                    clientProfActivity: types.CLIENT_PRMRY_CNCT_UPDATE_ERROR+timeVar,
                }
            }
        case types.CLIENT_ACTIVE_DEACTIVE_SUCCESS:
            const id = response.data.id; 
            if(response.status===200){
                return {
                    ...state,                   
                    items: state.items.filter(items => items.id !== id),
                    status:response.status,
                    activity:types.CLIENT_ACTIVE_DEACTIVE_SUCCESS,
                    activeStatus:response.data.active,
                    clientProfStatus: response.status,
                    clientProfActivity: types.CLIENT_ACTIVE_DEACTIVE_SUCCESS+timeVar,
                }     
            }else{
                return {
                    ...state,
                    status:response.status,
                    activity:types.CLIENT_ACTIVE_DEACTIVE_ERROR,
                    errorData:response.data,
                    clientProfStatus: response.status,
                    clientProfActivity: types.CLIENT_ACTIVE_DEACTIVE_ERROR+timeVar,
                }     
            }
               
        case types.MASTER_LOCATION_LIST_SUCCESS:
            return {
                ...state,
                status:response.status,
                locations:response.data,
                activity:types.MASTER_LOCATION_LIST_SUCCESS,
            }            
        case types.LIST_PRMY_CNCT_SUCCESS:
            return {
                ...state,
                status:response.status,
                prmryUsers:response.data.data,
                activity:types.LIST_PRMY_CNCT_SUCCESS,
            } 
        case types.RESEND_EMAIL_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    status:response.status,
                    activity:types.RESEND_EMAIL_SUCCESS,
                    clientProfStatus: response.status,
                    clientProfActivity: types.RESEND_EMAIL_SUCCESS+timeVar,
                } 
            }else{
                return {
                    ...state,
                    status:response.status,
                    activity:types.RESEND_EMAIL_ERROR,
                    errorData:response.data,
                    clientProfStatus: response.status,
                    clientProfActivity: types.RESEND_EMAIL_ERROR+timeVar,
                } 
            }
        
        case types.PROFILE_ROLE_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    roles:response.data.roles,
                    status:response.status,
                    subactivity:types.PROFILE_ROLE_SUCCESS,
                } 
            }else{
                return {
                    ...state,
                    status:response.status,
                    subactivity:types.PROFILE_ROLE_ERROR,
                    errorData:response.data
                } 
            }

        case types.CLIENT_CONTACT_LIST_SUCCESS:
            return {
                ...state,
                status:response.status,
                contactList:response.data,
                subactivity:types.CLIENT_CONTACT_LIST_SUCCESS,
                count:response.data.length,
            } 


        case types.CLIENT_CONTACT_ADD_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    status:response.status,
                    contactActivity:types.CLIENT_CONTACT_ADD_SUCCESS,
                    contactUserData:response.data 
                } 
            }else{
                return {
                    ...state,
                    status:response.status,
                    contactActivity:types.CLIENT_CONTACT_ADD_ERROR,
                    errorData:response.data
                } 
            }
        case types.CLIENT_CONTACT_ADD_SUCCESS:
            return {
                ...state,
                status:response.status,
                contactActivity:types.CLIENT_CONTACT_ADD_ERROR,
                errorData:response.data
            } 

        case types.ASS_USER_EDIT_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    status:response.status,
                    contactActivity:types.ASS_USER_EDIT_SUCCESS,
                    contactUser:{
                        userId:response.data.user_id,
                        firstName:response.data.first_name,
                        lastName:response.data.last_name,
                        contactNumber:response.data.mobile,
                        emailAddress:response.data.email,  
                        position:response.data.position===null?'':response.data.position,
                        logo:response.data.profile_picture===null?'':response.data.profile_picture,
                        emailVerify:response.data.email_verified,
                        role:response.data.role,
                        primary_contact:response.data.primary_contact?response.data.primary_contact:false, 
                        mute_mails:response.data.mute_mails,
                        mute_pushs:response.data.mute_pushs
                    }
                } 
            }else{
                return {
                    ...state,
                    status:response.status,
                    contactActivity:types.ASS_USER_EDIT_ERROR,
                } 
            }
        case types.ASS_USER_UPDATE_SUCCESS:
            if(response.status===200){
                return {
                    ...state,  
                    sendMailStatus:response.data.send_mail,             
                    status:response.status,
                    contactActivity:types.ASS_USER_UPDATE_SUCCESS                
                } 
            }else{
                return {
                    ...state,               
                    status:response.status,
                    contactActivity:types.ASS_USER_UPDATE_ERROR, 
                    errorData:response.data               
                } 
            }
           

        case types.ASS_USER_DELETE_SUCCESS:
            const userId = response.data.user_id;     
            if(response.status===200){ 
                return {
                    ...state,
                    items: state.contactList.filter(items => items.user.id !== userId),             
                    status: response.status,
                    subactivity:types.ASS_USER_DELETE_SUCCESS,   
                }
            }else{
                return {
                    ...state,
                    status: response.status,
                    subactivity:types.ASS_USER_DELETE_ERROR,   
                    errorData:response.data
                }
            }
        
        case types.CLIENT_CONTACT_DELETE_SUCCESS:
            // const userId = response.data.user_id;     
            if(response.status===200){ 
                return {
                    ...state,
                    //items: state.contactList.filter(items => items.user.id !== userId),             
                    status: response.status,
                    importSubactivity:types.CLIENT_CONTACT_DELETE_SUCCESS+timeVar,   
                }
            }else{
                return {
                    ...state,
                    status: response.status,
                    importSubactivity:types.CLIENT_CONTACT_DELETE_ERROR+timeVar,   
                    errorData:response.data
                }
            }

        //  CLIENT_CONTACT_DELETE_ERROR


        case types.CLIENT_IMPORT_SUCCESS:
            if(response.status===200){
                return {
                    ...state,   
                    clientId: response.data,
                    activity:types.CLIENT_IMPORT_SUCCESS,
                }     
            }else{
                return {
                    ...state,
                    status:response.status,
                    activity:types.CLIENT_IMPORT_ERROR,
                    subactivity:types.CLIENT_IMPORT_ERROR,
                    errorData: response.data,
                }     
            }
        
        case types.CLIENT_IMPORT_QUICK_FILE_SUCCESS:
            console.log('CLIENT_IMPORT_QUICK_FILE_SUCCESS response.data: ',response.data); 
            if(response.status===201){
                return {
                    ...state,   
                    clientId: response.data,
                    activity:types.CLIENT_IMPORT_QUICK_FILE_SUCCESS,
                }     
            }else{
                return {
                    ...state,
                    status:response.status,
                    activity:types.CLIENT_IMPORT_QUICK_FILE_ERROR,
                    subactivity:types.CLIENT_IMPORT_QUICK_FILE_ERROR,
                    errorData: response.data,
                }     
            }

        case types.CLIENT_CONTACT_IMPORT_SUCCESS:
            if(response.status===200){
                return {
                    ...state,   
                    contactImportData: response.data,
                    alreadyImported: response.data.already_imported,
                    activity:types.CLIENT_CONTACT_IMPORT_SUCCESS,
                    importSubactivity:types.CLIENT_CONTACT_IMPORT_SUCCESS+timeVar,
                }     
            }else{
                return {
                    ...state,
                    status:response.status,
                    activity:types.CLIENT_CONTACT_IMPORT_ERROR,
                    importSubactivity:types.CLIENT_CONTACT_IMPORT_ERROR+timeVar,
                    errorData: response.data,
                }     
            }  
    
        case types.CLIENT_DEPARTMENTS_LIST_SUCCESS:
            if(response.status===200){
                return {
                    ...state, 
                    status: response.status,  
                    clientDepartmentsList:response.data,
                    clientDeptActivity:types.CLIENT_DEPARTMENTS_LIST_SUCCESS+timeVar,  
                };
            }else{
                return {
                    ...state,
                    status: response.status, 
                    clientDeptActivity:types.CLIENT_DEPARTMENTS_LIST_ERROR+timeVar,    
                    errorData:response.data                            
                };
            }
            case types.CLIENT_DEPARTMENTS_LIST_ERROR:  
                return {
                    ...state,
                    status: response.status, 
                    clientDeptActivity:types.CLIENT_DEPARTMENTS_LIST_ERROR+timeVar,    
                    errorData:response.data                            
                };  



        case types.CLEAR:
            return {
                ...state,
                status:0,
                count:'',
                activity:types.CLEAR,
                subactivity:types.CLEAR,
                contactActivity:types.CLEAR,
            } 
       
        default:
            return state;
    }
};